import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import Pms_FbRo from "../rv/fb/rvo";
import {withRouter} from "../../lib/react/withRouter";
import sso from "../../sso";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Reg_Home extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.paa = [];
    this.state.aa = [];
    this.state.wnds = {};

    this.state.mna = [];
    this.state.mna.push({ mnid: "mn01", pos: "c1", text: "PRESENTKORT", desc: "Presentkorts register", link: "/pms/reg/pres" });
    this.state.mna.push({ mnid: "mn02", pos: "c1", text: "FÖRSKOTT", desc: "Registrerade förskott", link: "/pms/reg/fsk" });
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }
    mnc(pos) {
        var mna = [];
        for(var row of this.state.mna) {
            if(row.pos == pos) mna.push( row );
        }
        return mna;
    }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 480;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  rvn_open() {
      var self = this;
      var wnds = {};
      wnds.rvn = 1;
    this.setState({ wnds: wnds });
  }
  fknGo(url) {
    //alert(row.href);
      if(url == "/pms/fo/rvn") {
          this.rvn_open();
          return;
      }
    var row = {};
    row.url = url;
    sso.seo.sfkn = row;
    this.props.navigate(url);
  }

  render() {
    return (
    <div className="web-app">
        <div className="web-pg py-4 flex">
            <h3>Frontoffice</h3>
            <p>Frontoffice funktioner</p>

            <div className="divider_green"></div>

            <div className="web-row">
                <div className="flex-col flex">
                    { this.mnc("c1").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex-col flex">
                    { this.mnc("c2").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

            { this.state.wnds.rvn ?
        <Pms_FbRo show={this.state.wnds.rvn} ctx={this} store={this.props.store} backdrop={true}/>
            : null }
    </div>
  );
    }
}
export default withRouter(Reg_Home);
